import styled from 'styled-components';
import SpecialLabelText from './SpecialLabelText';

export const LegalAdvertisementText = styled(SpecialLabelText)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  padding: 16px 0;
`;
